// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hNyI","delete":"styles_delete__IFhc2","update":"styles_update__3zVgi","add":"styles_add__35iV0"};